// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pk-lc {
  width: 100%;
  color: #fff;
  font-family: Roboto, sans-serif;
  background: transparent;
}

.pk-lc button {
  color: inherit;
  font-family: inherit;
  cursor: pointer;
}

.pk-lc ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.pk-lc img {
  display: block;
  max-width: 100%;
}

.pk-lc__hero {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 16px 12px 15px;
  box-sizing: border-box;
}

.pk-lc__hero-col {
  flex: 1 1 50%;
  min-width: 280px;
  max-width: 50%;
  box-sizing: border-box;
}

.pk-lc__poster-wrap {
  padding: 10px;
  border-radius: 20px;
  background: #1a1a1a;
  box-sizing: border-box;
}

.pk-lc__poster {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
  width: 100%;
  padding-top: 28.57%;
  touch-action: pan-y;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.pk-lc__poster.is-dragging {
  cursor: grabbing;
}

.pk-lc__poster-track {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  will-change: transform;
}

.pk-lc__poster-slide {
  position: relative;
  flex: 0 0 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.pk-lc__poster-slide img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  pointer-events: none;
}

.pk-lc__dots {
  position: absolute;
  right: 10px;
  bottom: 0;
  z-index: 3;
  height: 21px;
  text-align: right;
}

button.pk-lc__dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  margin: 0 2px;
  padding: 0;
  border-radius: 50%;
  background: #404040;
  border: 1px solid #404040;
  opacity: 1;
  vertical-align: middle;
}

button.pk-lc__dot.is-on {
  background: #00b54c;
  border-color: #00b54c;
}

.pk-lc__netwin {
  padding: 10px;
  border-radius: 20px;
  overflow: hidden;
  background: linear-gradient(90deg, #372164 0%, #562daa 100%);
  box-sizing: border-box;
}

.pk-lc__netwin-inner {
  position: relative;
  width: 100%;
  padding-top: 28.57%;
  border-radius: 10px;
  overflow: hidden;
}

.pk-lc__netwin-inner::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 10px;
  background: linear-gradient(90deg, #281848 0%, #3d2078 100%);
}

.pk-lc__netwin-col {
  position: absolute;
  top: 0;
  width: 50%;
  height: 100%;
  overflow: hidden;
  z-index: 1;
}

.pk-lc__netwin-col.is-right {
  left: 50%;
}

.pk-lc__netwin-col.is-left {
  left: 0;
}

.pk-lc__netwin-track {
  height: 100%;
  transition: transform 0.3s ease;
}

.pk-lc__win {
  display: flex;
  align-items: center;
  height: 33.333%;
}

.pk-lc__win:nth-child(even) {
  background: rgba(0, 0, 0, 0.1);
}

.pk-lc__win-row {
  display: flex;
  width: 100%;
  height: 53px;
  padding: 0 5px;
  box-sizing: border-box;
}

.pk-lc__win-img {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30%;
}

.pk-lc__win-img span {
  position: relative;
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.2);
}

.pk-lc__win-img img {
  position: absolute;
  top: 0;
  left: 50%;
  height: 50px;
  width: auto;
  max-width: none;
  transform: translateX(-50%);
}

.pk-lc__win-detail {
  width: 70%;
}

.pk-lc__win-top,
.pk-lc__win-bot {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.pk-lc__win-user,
.pk-lc__win-amt {
  width: 50%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pk-lc__win-user {
  color: #fff;
  font: 400 0.9rem / 1.5 Roboto, sans-serif;
}

.pk-lc__win-amt {
  display: flex;
  font-family: Teko, sans-serif;
  font-size: 1.3rem;
  line-height: 1.5;
}

.pk-lc__win-ccy {
  padding-right: 5px;
  color: #00b54c;
  font-weight: 400;
}

.pk-lc__win-num {
  color: #fff;
  font-weight: 500;
}

.pk-lc__win-bot {
  color: #8f99a3;
  font: 400 0.8rem / 1.5 Roboto, sans-serif;
}

.pk-lc__win-game,
.pk-lc__win-when {
  width: 50%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pk-lc__toolbar {
  display: flex;
  align-items: center;
  height: 64px;
  margin: 0 12px;
  padding: 0 10px 0 20px;
  background: #1a1a1a;
  border-radius: 50px;
  box-sizing: border-box;
}

.pk-lc__cats {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  min-width: 0;
  height: 64px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: none;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  touch-action: pan-y;
}

.pk-lc__cats::-webkit-scrollbar {
  display: none;
}

.pk-lc__cats li {
  display: inline-block;
  flex: 0 0 auto;
}

button.pk-lc__cat {
  position: relative;
  display: inline-block;
  height: 64px;
  padding: 20px 15px;
  border: 0;
  background: none;
  color: #8f99a3;
  font: 600 16px / 24px Roboto, sans-serif;
  white-space: nowrap;
  transition: color 0.3s ease;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
}

button.pk-lc__cat:focus,
button.pk-lc__cat:focus-visible,
button.pk-lc__cat:active {
  border: 0;
  outline: none;
  box-shadow: none;
}

.pk-lc__cat::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 10px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background: #00b54c;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.pk-lc__cat:hover,
.pk-lc__cat.is-on {
  color: #fff;
}

.pk-lc__cat.is-on::after {
  opacity: 1;
}

.pk-lc__search {
  position: relative;
  flex: 0 0 270px;
  width: 270px;
  height: 44px;
  padding: 10px 10px 10px 45px;
  background: #222;
  border-radius: 250px;
  color: #8f99a3;
  box-sizing: border-box;
}

.pk-lc__search::before {
  content: '\\f002';
  font-family: FontAwesome, 'Font Awesome 5 Free', sans-serif;
  font-weight: 900;
  font-size: 1.1rem;
  color: #8f99a3;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.pk-lc__search input {
  width: 100%;
  height: 24px;
  border: 0;
  outline: 0;
  background: transparent;
  color: #fff;
  font: 600 16px / 24px Roboto, sans-serif;
}

.pk-lc__search input::placeholder {
  color: #757472;
}

.pk-lc__providers {
  display: flex;
  align-items: center;
  height: 60px;
  margin: 8px 12px 12px;
  min-width: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  scrollbar-width: none;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  touch-action: pan-y;
}

.pk-lc__providers.is-dragging,
.pk-lc__cats.is-dragging {
  cursor: grabbing;
}

.pk-lc__providers::-webkit-scrollbar {
  display: none;
}

.pk-lc__prov {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 60px;
  margin: 0 10px 0 0;
  flex: 0 0 auto;
  transition: width 0.3s ease;
}

.pk-lc__prov:hover {
  width: auto;
  min-width: 50px;
}

button.pk-lc__prov-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
  border: 0;
  border-radius: 50px;
  background: #1a1a1a;
  overflow: hidden;
  transition: width 0.3s ease, padding 0.3s ease, min-width 0.3s ease;
}

.pk-lc__prov:hover button.pk-lc__prov-btn {
  width: auto;
  min-width: 50px;
  padding: 0 14px;
}

button.pk-lc__prov-btn.is-on {
  box-shadow: inset 0 0 0 2px #00b54c;
}

.pk-lc__prov-ico,
.pk-lc__prov-name {
  position: absolute;
  transition: opacity 0.3s 0.2s ease, transform 0.3s 0.2s ease;
}

.pk-lc__prov-ico {
  width: 30px;
  max-height: 30px;
  object-fit: contain;
  opacity: 1;
  transform: none;
}

.pk-lc__prov-name {
  width: auto;
  overflow: visible;
  color: #fff;
  font: 500 10px / 1.2 Roboto, sans-serif;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  opacity: 0;
  transform: rotate(180deg);
}

.pk-lc__prov:hover .pk-lc__prov-ico {
  position: absolute;
  opacity: 0;
  transform: rotate(180deg);
}

.pk-lc__prov:hover .pk-lc__prov-name {
  position: relative;
  opacity: 1;
  transform: rotate(360deg);
}

.pk-lc__prov-btn.is-text {
  width: auto;
  min-width: 50px;
  padding: 0 8px;
}

.pk-lc__prov:has(.pk-lc__prov-btn.is-text) {
  width: auto;
  min-width: 50px;
}

.pk-lc__prov-btn.is-text .pk-lc__prov-name {
  position: relative;
  opacity: 1;
  transform: none;
  font-size: 8px;
}

.pk-lc__rec-row {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 2px;
  box-sizing: border-box;
}

.pk-lc__feat {
  position: relative;
  display: flex;
  flex: 0 1 33.333%;
  max-width: 33.333%;
  padding: 10px;
  box-sizing: border-box;
}

.pk-lc__feat-ring {
  position: relative;
  display: flex;
  flex: 1 1 auto;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
}

.pk-lc__feat-ring::before {
  content: '';
  position: absolute;
  left: -2px;
  top: -2px;
  width: calc(100% + 4px);
  height: calc(100% + 4px);
  z-index: 0;
  background: linear-gradient(
    135deg,
    #a1902e,
    #ffdb66 35%,
    #baa73e 40%,
    #fff8d4 44%,
    #6e5706 48%,
    #574300 52%,
    #fff6c7 56%,
    #ab8f00 76%,
    #ab8f00
  );
  animation: pk-lc-gold 5s linear infinite;
}

.pk-lc__feat-box {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 1 auto;
  width: 100%;
  overflow: hidden;
  padding: 20px;
  background: #000;
  border-radius: 10px;
  margin: 2px;
  box-sizing: border-box;
}

.pk-lc__feat-blur {
  position: absolute;
  inset: 0;
  z-index: 1;
  overflow: hidden;
  background: #1a1a1a;
  pointer-events: none;
}

.pk-lc__feat-blur img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  max-width: none;
  object-fit: fill;
  filter: blur(5px);
  transform: scale(1.3);
  opacity: 0;
  transition: opacity 0.45s ease;
}

.pk-lc__feat-blur img.is-on {
  opacity: 1;
}

@keyframes pk-lc-gold {
  from {
    transform: scale3d(2, 2, 1) rotate(0deg);
  }
  to {
    transform: scale3d(2, 2, 1) rotate(1turn);
  }
}

.pk-lc__feat-box h2 {
  position: relative;
  z-index: 5;
  margin: 0 0 10px;
  color: #fff;
  font: 500 1.225rem / 1.5 Roboto, sans-serif;
  text-align: center;
}

.pk-lc__feat-slider {
  position: relative;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pk-lc__feat-card {
  position: relative;
  width: 70%;
  max-width: 240px;
  aspect-ratio: 5 / 3;
  flex: 0 0 auto;
}

.pk-lc__feat-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.45s ease;
}

.pk-lc__feat-slide.is-on {
  opacity: 1;
  pointer-events: auto;
}

.pk-lc__feat-slide button.pk-lc__game {
  aspect-ratio: auto;
  height: 100%;
}

.pk-lc__nav {
  position: absolute;
  top: 50%;
  z-index: 3;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  background: none;
  color: #fff;
  font-size: 28px;
  line-height: 20px;
  transform: translateY(-50%);
}

.pk-lc__nav.is-prev {
  left: 8px;
}

.pk-lc__nav.is-next {
  right: 8px;
}

.pk-lc__top8 {
  flex: 0 1 66.666%;
  max-width: 66.666%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.pk-lc__top8 .pk-lc__cell {
  flex: 0 1 25%;
  max-width: 25%;
}

.pk-lc__grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 2px 24px;
  box-sizing: border-box;
}

.pk-lc__grid.is-full .pk-lc__cell {
  flex: 0 1 16.6667%;
  max-width: 16.6667%;
}

.pk-lc__cell {
  padding: 10px;
  box-sizing: border-box;
}

button.pk-lc__game {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 5 / 3;
  padding: 0;
  border: 0;
  background: #1a1a1a;
  overflow: hidden;
  border-radius: 11px;
  cursor: pointer;
}

.pk-lc__game-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
  transition: transform 1s ease, filter 0.3s ease;
}

.pk-lc__game::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 42%;
  z-index: 1;
  pointer-events: none;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.28) 60%, transparent);
}

.pk-lc__game::after {
  content: '';
  position: absolute;
  inset: 0;
  background: transparent;
  transition: background-color 0.3s ease;
}

.pk-lc__game:hover .pk-lc__game-bg {
  filter: blur(5px);
  transform: scale3d(1.1, 1.1, 1.1);
}

.pk-lc__game:hover::after {
  background: rgba(0, 0, 0, 0.6);
}

.pk-lc__brand,
.pk-lc__play,
.pk-lc__gname,
.pk-lc__game::after {
  pointer-events: none;
}

.pk-lc__brand {
  position: absolute;
  top: -100%;
  right: 10px;
  z-index: 2;
  color: #fff;
  font: 500 0.9rem / 1.5 Teko, sans-serif;
  transition: top 0.3s ease;
}

.pk-lc__game:hover .pk-lc__brand {
  top: 10px;
}

.pk-lc__play {
  position: absolute;
  top: 200%;
  left: 50%;
  z-index: 2;
  margin: 0;
  color: #fff;
  font: 700 1.2rem / 30px Roboto, sans-serif;
  text-transform: uppercase;
  letter-spacing: 0;
  opacity: 0.6;
  transform: translate(-50%, -50%);
  transition: top 0.3s ease, opacity 0.3s ease;
}

.pk-lc__game:hover .pk-lc__play {
  top: 50%;
}

.pk-lc__game:hover .pk-lc__play:hover {
  opacity: 1;
}

.pk-lc__gname {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  height: 30px;
  padding: 5px 10px;
  overflow: hidden;
  color: #fff;
  font: 400 0.85rem / 1.5 Roboto, sans-serif;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
  transition: width 0.3s ease;
}

.pk-lc__game:hover .pk-lc__gname {
  width: 55%;
}

.pk-lc__more-wrap {
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 24px 0;
}

button.pk-lc__more {
  padding: 10px 15px;
  border: 0;
  background: none;
  border-radius: 10px;
  color: #fff;
  font: 600 16px / 24px Roboto, sans-serif;
  text-transform: uppercase;
}

.pk-lc__empty,
.pk-lc__loading {
  width: 100%;
  padding: 40px 16px;
  color: #8f99a3;
  text-align: center;
}

.pk-lc__game.is-skeleton {
  pointer-events: none;
  cursor: default;
}

.pk-lc__game.is-skeleton .pk-lc__game-bg {
  background: linear-gradient(90deg, #161616 0%, #242424 45%, #161616 90%);
  background-size: 220% 100%;
  animation: pk-lc-shimmer 1.15s ease-in-out infinite;
}

.pk-lc__game.is-skeleton::before,
.pk-lc__game.is-skeleton::after,
.pk-lc__game.is-skeleton .pk-lc__brand,
.pk-lc__game.is-skeleton .pk-lc__play,
.pk-lc__game.is-skeleton .pk-lc__gname {
  opacity: 0;
}

@keyframes pk-lc-shimmer {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

@media (max-width: 1119px) {
  .pk-lc {
    background: #111;
  }

  /* Live: banner only — hide netwin column */
  .pk-lc__hero > .pk-lc__hero-col:nth-child(2) {
    display: none;
  }

  /* .live-casino-container: padding 0 15px; .live-casino-wrapper: padding-top 6px */
  .pk-lc__hero {
    padding: 6px 15px 0;
  }

  .pk-lc__hero-col {
    flex: 0 1 100%;
    max-width: 100%;
    min-width: 0;
  }

  /* .posterComponentWrapper: padding 0 6px */
  .pk-lc__poster-wrap {
    padding: 0 6px;
    border-radius: 0;
    background: transparent;
  }

  /* .posterSwiperWrapper: 318x90.85, radius 10px, bg #1a1a1a */
  .pk-lc__poster {
    border-radius: 10px;
    background: #1a1a1a;
  }

  .pk-lc__dots {
    right: 0;
    padding-right: 10px;
  }

  /* .gamesToolbar: full bleed, height 59.5, pad 0 0 0 10px, radius 50px, bg #1a1a1a */
  .pk-lc__toolbar {
    flex-wrap: nowrap;
    align-items: center;
    height: 59.5px;
    margin: 6px 0 0;
    padding: 0 10px 0 20px;
    border-radius: 50px;
  }

  .pk-lc__cats {
    height: 59.5px;
    margin-right: 10px;
  }

  button.pk-lc__cat {
    height: 59.5px;
    padding: 20px 15px;
    font-size: 13px;
    line-height: 19.5px;
  }

  /* Same open animation as landing \`.pk-land .pk-lc__search\` */
  .pk-lc__search {
    flex: 0 0 38px;
    width: 38px;
    min-width: 38px;
    height: 42px;
    margin: 0;
    padding: 7px 7px 7px 27px;
    overflow: hidden;
    transition: width 0.3s ease, flex-basis 0.3s ease, min-width 0.3s ease;
  }

  .pk-lc__search::before {
    left: 7px;
    font-size: 14px;
  }

  .pk-lc__search:hover,
  .pk-lc__search.is-filled,
  .pk-lc__search:focus-within {
    flex: 0 0 170px;
    flex-basis: 170px;
    width: 170px;
    min-width: 170px;
    max-width: 170px;
  }

  .pk-lc__providers {
    margin: 8px 0 0;
    padding: 0 10px;
  }

  /* .gameListWrapper: padding 0 10px; .recommendedGames: margin 0 -10px */
  .pk-lc__rec-row,
  .pk-lc__grid,
  .pk-lc__grid.is-full {
    flex-basis: 100%;
    max-width: 100%;
    padding: 0;
    margin: 0;
  }

  /* Featured recommended slider — full width like live xsmall-1 */
  .pk-lc__feat {
    flex: 0 1 100%;
    max-width: 100%;
    padding: 6px;
  }

  .pk-lc__feat-card {
    max-width: 205px;
  }

  /* Live .topEightContainer is empty on mobile */
  .pk-lc__top8 {
    display: none;
  }

  /* .allGames > .flex.xsmall-2: 50% width, padding 6px */
  .pk-lc__top8 .pk-lc__cell,
  .pk-lc__grid.is-full .pk-lc__cell,
  .pk-lc__cell {
    flex-basis: 50%;
    max-width: 50%;
    padding: 6px;
  }

  button.pk-lc__game {
    border-radius: 10px;
  }
}

/* iPhone only. pan-y blocks sideways swipes in Safari. */
@supports (-webkit-touch-callout: none) {
  .pk-lc__cats,
  .pk-lc__providers {
    touch-action: pan-x pan-y;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/PlayKaroLiveCasino/PlayKaroLiveCasino.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,YAAY;EACZ,WAAW;EACX,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,wCAAwC;EACxC,mBAAmB;EACnB,2BAA2B;EAC3B,aAAa;EACb,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;;;EAGE,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,2DAA2D;EAC3D,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,UAAU;EACV;;;;;;;;;;;GAWC;EACD,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,8FAA8F;AAChG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,SAAS;EACT,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,wEAAwE;EACxE,0BAA0B;EAC1B,mDAAmD;AACrD;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,aAAa;EACf;;EAEA,kFAAkF;EAClF;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA,2CAA2C;EAC3C;IACE,cAAc;IACd,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA,6DAA6D;EAC7D;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,QAAQ;IACR,mBAAmB;EACrB;;EAEA,oFAAoF;EACpF;IACE,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;EACrB;;EAEA,6DAA6D;EAC7D;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,sEAAsE;EACxE;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;;;IAGE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,wEAAwE;EACxE;;;IAGE,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,SAAS;EACX;;EAEA,gEAAgE;EAChE;IACE,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA,+CAA+C;EAC/C;IACE,aAAa;EACf;;EAEA,uDAAuD;EACvD;;;IAGE,eAAe;IACf,cAAc;IACd,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,yDAAyD;AACzD;EACE;;IAEE,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;EAChC;AACF","sourcesContent":[".pk-lc {\n  width: 100%;\n  color: #fff;\n  font-family: Roboto, sans-serif;\n  background: transparent;\n}\n\n.pk-lc button {\n  color: inherit;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.pk-lc ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.pk-lc img {\n  display: block;\n  max-width: 100%;\n}\n\n.pk-lc__hero {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 16px 12px 15px;\n  box-sizing: border-box;\n}\n\n.pk-lc__hero-col {\n  flex: 1 1 50%;\n  min-width: 280px;\n  max-width: 50%;\n  box-sizing: border-box;\n}\n\n.pk-lc__poster-wrap {\n  padding: 10px;\n  border-radius: 20px;\n  background: #1a1a1a;\n  box-sizing: border-box;\n}\n\n.pk-lc__poster {\n  position: relative;\n  overflow: hidden;\n  border-radius: 10px;\n  width: 100%;\n  padding-top: 28.57%;\n  touch-action: pan-y;\n  cursor: grab;\n  user-select: none;\n}\n\n.pk-lc__poster.is-dragging {\n  cursor: grabbing;\n}\n\n.pk-lc__poster-track {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  will-change: transform;\n}\n\n.pk-lc__poster-slide {\n  position: relative;\n  flex: 0 0 100%;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.pk-lc__poster-slide img {\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  pointer-events: none;\n}\n\n.pk-lc__dots {\n  position: absolute;\n  right: 10px;\n  bottom: 0;\n  z-index: 3;\n  height: 21px;\n  text-align: right;\n}\n\nbutton.pk-lc__dot {\n  display: inline-block;\n  width: 9px;\n  height: 9px;\n  margin: 0 2px;\n  padding: 0;\n  border-radius: 50%;\n  background: #404040;\n  border: 1px solid #404040;\n  opacity: 1;\n  vertical-align: middle;\n}\n\nbutton.pk-lc__dot.is-on {\n  background: #00b54c;\n  border-color: #00b54c;\n}\n\n.pk-lc__netwin {\n  padding: 10px;\n  border-radius: 20px;\n  overflow: hidden;\n  background: linear-gradient(90deg, #372164 0%, #562daa 100%);\n  box-sizing: border-box;\n}\n\n.pk-lc__netwin-inner {\n  position: relative;\n  width: 100%;\n  padding-top: 28.57%;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.pk-lc__netwin-inner::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  border-radius: 10px;\n  background: linear-gradient(90deg, #281848 0%, #3d2078 100%);\n}\n\n.pk-lc__netwin-col {\n  position: absolute;\n  top: 0;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.pk-lc__netwin-col.is-right {\n  left: 50%;\n}\n\n.pk-lc__netwin-col.is-left {\n  left: 0;\n}\n\n.pk-lc__netwin-track {\n  height: 100%;\n  transition: transform 0.3s ease;\n}\n\n.pk-lc__win {\n  display: flex;\n  align-items: center;\n  height: 33.333%;\n}\n\n.pk-lc__win:nth-child(even) {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.pk-lc__win-row {\n  display: flex;\n  width: 100%;\n  height: 53px;\n  padding: 0 5px;\n  box-sizing: border-box;\n}\n\n.pk-lc__win-img {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 30%;\n}\n\n.pk-lc__win-img span {\n  position: relative;\n  width: 50px;\n  height: 50px;\n  overflow: hidden;\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, 0.2);\n}\n\n.pk-lc__win-img img {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  height: 50px;\n  width: auto;\n  max-width: none;\n  transform: translateX(-50%);\n}\n\n.pk-lc__win-detail {\n  width: 70%;\n}\n\n.pk-lc__win-top,\n.pk-lc__win-bot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.pk-lc__win-user,\n.pk-lc__win-amt {\n  width: 50%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.pk-lc__win-user {\n  color: #fff;\n  font: 400 0.9rem / 1.5 Roboto, sans-serif;\n}\n\n.pk-lc__win-amt {\n  display: flex;\n  font-family: Teko, sans-serif;\n  font-size: 1.3rem;\n  line-height: 1.5;\n}\n\n.pk-lc__win-ccy {\n  padding-right: 5px;\n  color: #00b54c;\n  font-weight: 400;\n}\n\n.pk-lc__win-num {\n  color: #fff;\n  font-weight: 500;\n}\n\n.pk-lc__win-bot {\n  color: #8f99a3;\n  font: 400 0.8rem / 1.5 Roboto, sans-serif;\n}\n\n.pk-lc__win-game,\n.pk-lc__win-when {\n  width: 50%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.pk-lc__toolbar {\n  display: flex;\n  align-items: center;\n  height: 64px;\n  margin: 0 12px;\n  padding: 0 10px 0 20px;\n  background: #1a1a1a;\n  border-radius: 50px;\n  box-sizing: border-box;\n}\n\n.pk-lc__cats {\n  display: flex;\n  flex: 1 1 auto;\n  align-items: stretch;\n  min-width: 0;\n  height: 64px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  scrollbar-width: none;\n  cursor: grab;\n  user-select: none;\n  touch-action: pan-y;\n}\n\n.pk-lc__cats::-webkit-scrollbar {\n  display: none;\n}\n\n.pk-lc__cats li {\n  display: inline-block;\n  flex: 0 0 auto;\n}\n\nbutton.pk-lc__cat {\n  position: relative;\n  display: inline-block;\n  height: 64px;\n  padding: 20px 15px;\n  border: 0;\n  background: none;\n  color: #8f99a3;\n  font: 600 16px / 24px Roboto, sans-serif;\n  white-space: nowrap;\n  transition: color 0.3s ease;\n  outline: none;\n  box-shadow: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\nbutton.pk-lc__cat:focus,\nbutton.pk-lc__cat:focus-visible,\nbutton.pk-lc__cat:active {\n  border: 0;\n  outline: none;\n  box-shadow: none;\n}\n\n.pk-lc__cat::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: 10px;\n  width: 5px;\n  height: 5px;\n  border-radius: 5px;\n  background: #00b54c;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.pk-lc__cat:hover,\n.pk-lc__cat.is-on {\n  color: #fff;\n}\n\n.pk-lc__cat.is-on::after {\n  opacity: 1;\n}\n\n.pk-lc__search {\n  position: relative;\n  flex: 0 0 270px;\n  width: 270px;\n  height: 44px;\n  padding: 10px 10px 10px 45px;\n  background: #222;\n  border-radius: 250px;\n  color: #8f99a3;\n  box-sizing: border-box;\n}\n\n.pk-lc__search::before {\n  content: '\\f002';\n  font-family: FontAwesome, 'Font Awesome 5 Free', sans-serif;\n  font-weight: 900;\n  font-size: 1.1rem;\n  color: #8f99a3;\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.pk-lc__search input {\n  width: 100%;\n  height: 24px;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: #fff;\n  font: 600 16px / 24px Roboto, sans-serif;\n}\n\n.pk-lc__search input::placeholder {\n  color: #757472;\n}\n\n.pk-lc__providers {\n  display: flex;\n  align-items: center;\n  height: 60px;\n  margin: 8px 12px 12px;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n  scrollbar-width: none;\n  cursor: grab;\n  user-select: none;\n  touch-action: pan-y;\n}\n\n.pk-lc__providers.is-dragging,\n.pk-lc__cats.is-dragging {\n  cursor: grabbing;\n}\n\n.pk-lc__providers::-webkit-scrollbar {\n  display: none;\n}\n\n.pk-lc__prov {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 60px;\n  margin: 0 10px 0 0;\n  flex: 0 0 auto;\n  transition: width 0.3s ease;\n}\n\n.pk-lc__prov:hover {\n  width: auto;\n  min-width: 50px;\n}\n\nbutton.pk-lc__prov-btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  padding: 0;\n  border: 0;\n  border-radius: 50px;\n  background: #1a1a1a;\n  overflow: hidden;\n  transition: width 0.3s ease, padding 0.3s ease, min-width 0.3s ease;\n}\n\n.pk-lc__prov:hover button.pk-lc__prov-btn {\n  width: auto;\n  min-width: 50px;\n  padding: 0 14px;\n}\n\nbutton.pk-lc__prov-btn.is-on {\n  box-shadow: inset 0 0 0 2px #00b54c;\n}\n\n.pk-lc__prov-ico,\n.pk-lc__prov-name {\n  position: absolute;\n  transition: opacity 0.3s 0.2s ease, transform 0.3s 0.2s ease;\n}\n\n.pk-lc__prov-ico {\n  width: 30px;\n  max-height: 30px;\n  object-fit: contain;\n  opacity: 1;\n  transform: none;\n}\n\n.pk-lc__prov-name {\n  width: auto;\n  overflow: visible;\n  color: #fff;\n  font: 500 10px / 1.2 Roboto, sans-serif;\n  text-align: center;\n  text-transform: uppercase;\n  white-space: nowrap;\n  opacity: 0;\n  transform: rotate(180deg);\n}\n\n.pk-lc__prov:hover .pk-lc__prov-ico {\n  position: absolute;\n  opacity: 0;\n  transform: rotate(180deg);\n}\n\n.pk-lc__prov:hover .pk-lc__prov-name {\n  position: relative;\n  opacity: 1;\n  transform: rotate(360deg);\n}\n\n.pk-lc__prov-btn.is-text {\n  width: auto;\n  min-width: 50px;\n  padding: 0 8px;\n}\n\n.pk-lc__prov:has(.pk-lc__prov-btn.is-text) {\n  width: auto;\n  min-width: 50px;\n}\n\n.pk-lc__prov-btn.is-text .pk-lc__prov-name {\n  position: relative;\n  opacity: 1;\n  transform: none;\n  font-size: 8px;\n}\n\n.pk-lc__rec-row {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 0 2px;\n  box-sizing: border-box;\n}\n\n.pk-lc__feat {\n  position: relative;\n  display: flex;\n  flex: 0 1 33.333%;\n  max-width: 33.333%;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.pk-lc__feat-ring {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 10px;\n}\n\n.pk-lc__feat-ring::before {\n  content: '';\n  position: absolute;\n  left: -2px;\n  top: -2px;\n  width: calc(100% + 4px);\n  height: calc(100% + 4px);\n  z-index: 0;\n  background: linear-gradient(\n    135deg,\n    #a1902e,\n    #ffdb66 35%,\n    #baa73e 40%,\n    #fff8d4 44%,\n    #6e5706 48%,\n    #574300 52%,\n    #fff6c7 56%,\n    #ab8f00 76%,\n    #ab8f00\n  );\n  animation: pk-lc-gold 5s linear infinite;\n}\n\n.pk-lc__feat-box {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  flex: 1 1 auto;\n  width: 100%;\n  overflow: hidden;\n  padding: 20px;\n  background: #000;\n  border-radius: 10px;\n  margin: 2px;\n  box-sizing: border-box;\n}\n\n.pk-lc__feat-blur {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  overflow: hidden;\n  background: #1a1a1a;\n  pointer-events: none;\n}\n\n.pk-lc__feat-blur img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  object-fit: fill;\n  filter: blur(5px);\n  transform: scale(1.3);\n  opacity: 0;\n  transition: opacity 0.45s ease;\n}\n\n.pk-lc__feat-blur img.is-on {\n  opacity: 1;\n}\n\n@keyframes pk-lc-gold {\n  from {\n    transform: scale3d(2, 2, 1) rotate(0deg);\n  }\n  to {\n    transform: scale3d(2, 2, 1) rotate(1turn);\n  }\n}\n\n.pk-lc__feat-box h2 {\n  position: relative;\n  z-index: 5;\n  margin: 0 0 10px;\n  color: #fff;\n  font: 500 1.225rem / 1.5 Roboto, sans-serif;\n  text-align: center;\n}\n\n.pk-lc__feat-slider {\n  position: relative;\n  z-index: 5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pk-lc__feat-card {\n  position: relative;\n  width: 70%;\n  max-width: 240px;\n  aspect-ratio: 5 / 3;\n  flex: 0 0 auto;\n}\n\n.pk-lc__feat-slide {\n  position: absolute;\n  inset: 0;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.45s ease;\n}\n\n.pk-lc__feat-slide.is-on {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.pk-lc__feat-slide button.pk-lc__game {\n  aspect-ratio: auto;\n  height: 100%;\n}\n\n.pk-lc__nav {\n  position: absolute;\n  top: 50%;\n  z-index: 3;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: #fff;\n  font-size: 28px;\n  line-height: 20px;\n  transform: translateY(-50%);\n}\n\n.pk-lc__nav.is-prev {\n  left: 8px;\n}\n\n.pk-lc__nav.is-next {\n  right: 8px;\n}\n\n.pk-lc__top8 {\n  flex: 0 1 66.666%;\n  max-width: 66.666%;\n  display: flex;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n}\n\n.pk-lc__top8 .pk-lc__cell {\n  flex: 0 1 25%;\n  max-width: 25%;\n}\n\n.pk-lc__grid {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: 0 2px 24px;\n  box-sizing: border-box;\n}\n\n.pk-lc__grid.is-full .pk-lc__cell {\n  flex: 0 1 16.6667%;\n  max-width: 16.6667%;\n}\n\n.pk-lc__cell {\n  padding: 10px;\n  box-sizing: border-box;\n}\n\nbutton.pk-lc__game {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 5 / 3;\n  padding: 0;\n  border: 0;\n  background: #1a1a1a;\n  overflow: hidden;\n  border-radius: 11px;\n  cursor: pointer;\n}\n\n.pk-lc__game-bg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: fill;\n  transition: transform 1s ease, filter 0.3s ease;\n}\n\n.pk-lc__game::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 42%;\n  z-index: 1;\n  pointer-events: none;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.82), rgba(0, 0, 0, 0.28) 60%, transparent);\n}\n\n.pk-lc__game::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: transparent;\n  transition: background-color 0.3s ease;\n}\n\n.pk-lc__game:hover .pk-lc__game-bg {\n  filter: blur(5px);\n  transform: scale3d(1.1, 1.1, 1.1);\n}\n\n.pk-lc__game:hover::after {\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.pk-lc__brand,\n.pk-lc__play,\n.pk-lc__gname,\n.pk-lc__game::after {\n  pointer-events: none;\n}\n\n.pk-lc__brand {\n  position: absolute;\n  top: -100%;\n  right: 10px;\n  z-index: 2;\n  color: #fff;\n  font: 500 0.9rem / 1.5 Teko, sans-serif;\n  transition: top 0.3s ease;\n}\n\n.pk-lc__game:hover .pk-lc__brand {\n  top: 10px;\n}\n\n.pk-lc__play {\n  position: absolute;\n  top: 200%;\n  left: 50%;\n  z-index: 2;\n  margin: 0;\n  color: #fff;\n  font: 700 1.2rem / 30px Roboto, sans-serif;\n  text-transform: uppercase;\n  letter-spacing: 0;\n  opacity: 0.6;\n  transform: translate(-50%, -50%);\n  transition: top 0.3s ease, opacity 0.3s ease;\n}\n\n.pk-lc__game:hover .pk-lc__play {\n  top: 50%;\n}\n\n.pk-lc__game:hover .pk-lc__play:hover {\n  opacity: 1;\n}\n\n.pk-lc__gname {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n  height: 30px;\n  padding: 5px 10px;\n  overflow: hidden;\n  color: #fff;\n  font: 400 0.85rem / 1.5 Roboto, sans-serif;\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  box-sizing: border-box;\n  transition: width 0.3s ease;\n}\n\n.pk-lc__game:hover .pk-lc__gname {\n  width: 55%;\n}\n\n.pk-lc__more-wrap {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  padding: 24px 0;\n}\n\nbutton.pk-lc__more {\n  padding: 10px 15px;\n  border: 0;\n  background: none;\n  border-radius: 10px;\n  color: #fff;\n  font: 600 16px / 24px Roboto, sans-serif;\n  text-transform: uppercase;\n}\n\n.pk-lc__empty,\n.pk-lc__loading {\n  width: 100%;\n  padding: 40px 16px;\n  color: #8f99a3;\n  text-align: center;\n}\n\n.pk-lc__game.is-skeleton {\n  pointer-events: none;\n  cursor: default;\n}\n\n.pk-lc__game.is-skeleton .pk-lc__game-bg {\n  background: linear-gradient(90deg, #161616 0%, #242424 45%, #161616 90%);\n  background-size: 220% 100%;\n  animation: pk-lc-shimmer 1.15s ease-in-out infinite;\n}\n\n.pk-lc__game.is-skeleton::before,\n.pk-lc__game.is-skeleton::after,\n.pk-lc__game.is-skeleton .pk-lc__brand,\n.pk-lc__game.is-skeleton .pk-lc__play,\n.pk-lc__game.is-skeleton .pk-lc__gname {\n  opacity: 0;\n}\n\n@keyframes pk-lc-shimmer {\n  0% {\n    background-position: 100% 0;\n  }\n  100% {\n    background-position: -100% 0;\n  }\n}\n\n@media (max-width: 1119px) {\n  .pk-lc {\n    background: #111;\n  }\n\n  /* Live: banner only — hide netwin column */\n  .pk-lc__hero > .pk-lc__hero-col:nth-child(2) {\n    display: none;\n  }\n\n  /* .live-casino-container: padding 0 15px; .live-casino-wrapper: padding-top 6px */\n  .pk-lc__hero {\n    padding: 6px 15px 0;\n  }\n\n  .pk-lc__hero-col {\n    flex: 0 1 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  /* .posterComponentWrapper: padding 0 6px */\n  .pk-lc__poster-wrap {\n    padding: 0 6px;\n    border-radius: 0;\n    background: transparent;\n  }\n\n  /* .posterSwiperWrapper: 318x90.85, radius 10px, bg #1a1a1a */\n  .pk-lc__poster {\n    border-radius: 10px;\n    background: #1a1a1a;\n  }\n\n  .pk-lc__dots {\n    right: 0;\n    padding-right: 10px;\n  }\n\n  /* .gamesToolbar: full bleed, height 59.5, pad 0 0 0 10px, radius 50px, bg #1a1a1a */\n  .pk-lc__toolbar {\n    flex-wrap: nowrap;\n    align-items: center;\n    height: 59.5px;\n    margin: 6px 0 0;\n    padding: 0 10px 0 20px;\n    border-radius: 50px;\n  }\n\n  .pk-lc__cats {\n    height: 59.5px;\n    margin-right: 10px;\n  }\n\n  button.pk-lc__cat {\n    height: 59.5px;\n    padding: 20px 15px;\n    font-size: 13px;\n    line-height: 19.5px;\n  }\n\n  /* Same open animation as landing `.pk-land .pk-lc__search` */\n  .pk-lc__search {\n    flex: 0 0 38px;\n    width: 38px;\n    min-width: 38px;\n    height: 42px;\n    margin: 0;\n    padding: 7px 7px 7px 27px;\n    overflow: hidden;\n    transition: width 0.3s ease, flex-basis 0.3s ease, min-width 0.3s ease;\n  }\n\n  .pk-lc__search::before {\n    left: 7px;\n    font-size: 14px;\n  }\n\n  .pk-lc__search:hover,\n  .pk-lc__search.is-filled,\n  .pk-lc__search:focus-within {\n    flex: 0 0 170px;\n    flex-basis: 170px;\n    width: 170px;\n    min-width: 170px;\n    max-width: 170px;\n  }\n\n  .pk-lc__providers {\n    margin: 8px 0 0;\n    padding: 0 10px;\n  }\n\n  /* .gameListWrapper: padding 0 10px; .recommendedGames: margin 0 -10px */\n  .pk-lc__rec-row,\n  .pk-lc__grid,\n  .pk-lc__grid.is-full {\n    flex-basis: 100%;\n    max-width: 100%;\n    padding: 0;\n    margin: 0;\n  }\n\n  /* Featured recommended slider — full width like live xsmall-1 */\n  .pk-lc__feat {\n    flex: 0 1 100%;\n    max-width: 100%;\n    padding: 6px;\n  }\n\n  .pk-lc__feat-card {\n    max-width: 205px;\n  }\n\n  /* Live .topEightContainer is empty on mobile */\n  .pk-lc__top8 {\n    display: none;\n  }\n\n  /* .allGames > .flex.xsmall-2: 50% width, padding 6px */\n  .pk-lc__top8 .pk-lc__cell,\n  .pk-lc__grid.is-full .pk-lc__cell,\n  .pk-lc__cell {\n    flex-basis: 50%;\n    max-width: 50%;\n    padding: 6px;\n  }\n\n  button.pk-lc__game {\n    border-radius: 10px;\n  }\n}\n\n/* iPhone only. pan-y blocks sideways swipes in Safari. */\n@supports (-webkit-touch-callout: none) {\n  .pk-lc__cats,\n  .pk-lc__providers {\n    touch-action: pan-x pan-y;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
